import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=bd68270e&scoped=true"
import script from "./header.component.vue?vue&type=script&lang=js"
export * from "./header.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd68270e",
  null
  
)

export default component.exports